import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-uplevel",
  "use": "icon-uplevel-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" id=\"icon-uplevel\"><path fill=\"#2cd9fc\" fill-rule=\"evenodd\" d=\"M2.258 3.374h1.874l-.007 3.001c0 .797.502 1.423 1.287 1.493l.15.007 4.93.001v-.75l-4.93-.001c-.412 0-.687-.3-.687-.75l.007-3.001h1.876l-2.25-2.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol